import React, { useState } from "react";
import { Card, CardBody, Badge } from "reactstrap";
import styles from "./processCard.module.scss";
import { fetchBusByPid } from "./utils";
import MultiSelectCellComponentWithSearch from "views/pages/manage/common/commonComponents/SearchFilterView/MultiSelectCellComponentWithSearch";
import { ReactComponent as EyeIcon } from "../../../../../../../assets/img/svg/eye.svg"
import AButton from "views/pages/manage/common/form-fields-mui/AButton";
import ResendEmailDialog from "./ResendEmailDialog";
import { ReactComponent as DownloadIcon } from "assets/img/svg/downloadBlackV2.svg"
import { downloadFileByS3Key } from "views/pages/manage/edpOps/studentDetails/paymentSummary/viewInvoice/ViewInvoicesDialog";
import { failureToast } from "views/pages/manage/common/utils/methods/toasterFunctions/function";

const TAG_STYLES = {
  Franchise: { bg: "#dff5f2", color: "#1f7a6e" },
  ALC: { bg: "#dff5f2", color: "#1f7a6e" },
  "F+EC": { bg: "#efe9ff", color: "#6b46c1" },
  "Pure Flip": { bg: "#ffe9d6", color: "#dd6b20" },
  "Single Business Area": { bg: "#e7edff", color: "#3b5bdb" }
};

const STATUS_STYLES = {
  Completed: { bg: "#daf5ea", color: "#2f9e44" },
  "In Progress": { bg: "#e7f1ff", color: "#3b82f6" },
  Failed: { bg: "#fde2e2", color: "#e03131" }
};


const ProcessCard = React.memo(({ data, emailPopupHandler, sapPotingPopupHandler, isBulkAccess, isCreateAccess, setLoading, isSapPostingPermission }) => {
  const {
    id,
    tags,
    fromDate,
    toDate,
    runOnDate,
    runOnTime,
    runBy,
    status,
    sapPostingStatus,
  } = data;
  const [buList, setBuList] = useState()
  const isCompleted = status === "Completed";
  const isSapPostingCompleted = sapPostingStatus === "Completed"
  const isEmailTriggered = data?.emailStatus === "TRIGGERED";
  const isSapPostingInProgress = sapPostingStatus === "In Progress";
  const isSapPostingFailed = sapPostingStatus === "FAILED"


  const [openResendDialog, setOpenResendDialog] = useState(false);
  const [selectedData, setSelectedData] = useState(null);

  console.log('isSapPostingPermission',isSapPostingPermission )

  const handleEmailClick = (data) => {
    if (data?.emailStatus === "TRIGGERED") {
      setSelectedData(data);
      setOpenResendDialog(true);
    } else {
      emailPopupHandler(data);
    }
  };

  const handleConfirmResend = () => {
    setOpenResendDialog(false);
    emailPopupHandler(selectedData); // reuse same handler
  };
  const viewBuHandler = async (pid) => {
    const res = await fetchBusByPid(pid);
    setBuList(res);
  }
  const emailStyle = {
    bg: "linear-gradient(135deg, #34d399, #16a34a)", // vibrant green gradient
    color: "#ffffff"
  };
  const sapPostStatus = data?.raw?.sapPostStatus;

  const badgeConfig = {
    COMPLETED: {
      text: "Sap Posting Completed",
      style: {
        background: "#DCFCE7",
        color: "#166534",
        boxShadow: "0 2px 6px rgba(22, 163, 74, 0.3)"
      }
    },
    IN_PROGRESS: {
      text: "Sap Posting In Progress",
      style: {
        background: "#FEF9C3",
        color: "#854D0E",
        boxShadow: "0 2px 6px rgba(234, 179, 8, 0.3)"
      }
    },
    FAILED: {
      text: "Sap Posting Failed",
      style: {
        background: "#fde2e2",
        color: "#e03131",
        boxShadow: "0 2px 6px rgba(234, 179, 8, 0.3)"
      }
    }
  };

  const downloadHandler = async (s3Key) => {
    if (!s3Key) {
      failureToast("Currently report generation in progress. Please refresh the page and try again.")
      return;
    }
    setLoading(true);
    await downloadFileByS3Key(s3Key);
    setLoading(false);
  }
const isBeforeOrEqualCutoffDate = new Date(data?.raw?.endDate) <= new Date("2026-02-28");
console.log("isBeforeOrEqualCutoffDate:",new Date(data?.raw?.endDate), isBeforeOrEqualCutoffDate, "data?.raw?.endDate:", data?.raw?.endDate)
  return (<>
    <Card className={`${styles.card} ${styles.hoverCard}`}>
      <CardBody className="px-4 py-3">

        {/* Header */}
        <div className={styles.header}>
          <span className="text-muted small">Process ID:</span>
          <span className={styles.processId}>{id}</span>

          {data?.emailStatus == "TRIGGERED" && <Badge
            key={`${data?.id}-email`}
            pill
            style={{
              background: emailStyle.bg,
              color: emailStyle.color,
              fontWeight: 700,
              fontSize: "12px",
              padding: "6px 12px",
              display: "flex",
              alignItems: "center",
              gap: "6px",
              boxShadow: "0 2px 6px rgba(22, 163, 74, 0.3)"
            }}
          >
            Email Triggered
          </Badge>}
          {["COMPLETED", "IN_PROGRESS", "FAILED"].includes(sapPostStatus) && (
            <Badge
              key={`${data?.id}-sap`}
              pill
              style={{
                ...badgeConfig[sapPostStatus].style,
                fontWeight: 700,
                fontSize: "12px",
                padding: "6px 12px",
                display: "flex",
                alignItems: "center",
                gap: "6px"
              }}
            >
              {badgeConfig[sapPostStatus].text}
            </Badge>
          )}

        </div>

        {/* Tags */}
        <div className={styles.tags}>
          {tags?.map((tag, i) => {
            const style = TAG_STYLES[tag] || { bg: "#eee", color: "#333" };

            return (
              <Badge
                key={`${tag}-${i}`}
                pill
                style={{
                  background: style.bg,
                  color: style.color,
                  fontWeight: 600,
                  fontSize: "12px",
                  padding: "6px 12px"
                }}
              >
                {tag}
              </Badge>
            );
          })}
        </div>

        {/* Grid */}
        <div className={styles.grid}>

          <div>
            <div className="text-muted small">Business Area</div>
            <div className="fw-semibold cursor">
              {!buList ? <AButton variant="link" size="sm" onClick={() => viewBuHandler(id)}>
                View
              </AButton> : <MultiSelectCellComponentWithSearch
                title={"Business Area"}
                data={buList}
              />}
            </div>
          </div>

          <div>
            <div className="text-muted small">From Date</div>
            <div className="color-dark">{fromDate}</div>
          </div>

          <div>
            <div className="text-muted small">To Date</div>
            <div className="color-dark">{toDate}</div>
          </div>

          <div>
            <div className="text-muted small mt-3">Process Run On</div>
            <div className="color-dark">
              {runOnDate}
              <div className="text-muted small color-dark">
                {runOnTime}
              </div>
            </div>
          </div>

          <div>
            <div className="text-muted small">Process Run By</div>
            <div className="color-dark">{runBy}</div>
          </div>

          <div className={styles.center}>
            <div className="text-muted small">Status</div>

            <Badge
              pill
              style={{
                background: STATUS_STYLES[status]?.bg,
                color: STATUS_STYLES[status]?.color,
                padding: "6px 14px",
                fontWeight: 500
              }}
            >
              {status}
            </Badge>
          </div>

          {(isCreateAccess || isBulkAccess) && <div className={styles.center}>
            <div className="text-muted small">Download</div>
            <div
              className="cursor"
              onClick={() => downloadHandler(data?.raw?.zipS3Key)}
            >
              <DownloadIcon />
            </div>
          </div>}

          {(isCreateAccess || isBulkAccess) && <div className={styles.center}>
            <div className="text-muted small">Email</div>
            <div
              className="cursor"
              style={{ opacity: isCompleted ? 1 : 0.5, pointerEvents: isCompleted ? "auto" : "none" }}
              onClick={() => isCompleted && handleEmailClick(data)}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <line x1="22" y1="2" x2="11" y2="13" />
                <polygon points="22 2 15 22 11 13 2 9 22 2" />
              </svg>
            </div>
          </div>}

          {(isBulkAccess || isCreateAccess) && (
            <div className={styles.center}>
              <div className="text-muted small">SAP Posting</div>

              <div
                className={`${styles.sapBox} cursor`}
                style={{
                  opacity:
                    isCompleted && isSapPostingPermission && !isSapPostingCompleted && isEmailTriggered && !isSapPostingInProgress && !isBeforeOrEqualCutoffDate
                      ? 1
                      : 0.5,
                  pointerEvents:
                    isCompleted && isSapPostingPermission && !isSapPostingCompleted && !isSapPostingInProgress && !isBeforeOrEqualCutoffDate
                      ? "auto"
                      : "none",
                }}
                onClick={() =>
                  isCompleted &&
                  isSapPostingPermission &&
                  !isSapPostingCompleted && isEmailTriggered &&
                  !isSapPostingInProgress &&
                  !isBeforeOrEqualCutoffDate &&
                  sapPotingPopupHandler(data)
                }
              >
                <img
                  src="https://upload.wikimedia.org/wikipedia/commons/5/59/SAP_2011_logo.svg"
                  alt="sap"
                />
              </div>
            </div>
          )}

        </div>
      </CardBody>
    </Card>
    <ResendEmailDialog
      open={openResendDialog}
      onClose={() => setOpenResendDialog(false)}
      onConfirm={handleConfirmResend}
    />
  </>

  );
});

export default ProcessCard;